import React, { useContext, useEffect, useState } from "react";
import {
  UmbracoContext,
  UmbracoUpStep,
} from "../../components/Umbraco/UmbracoContext";
import utils from "utils";
import { Parser as HtmlToReactParser } from "html-to-react";
import { IconTiny, Row, Line, Between } from "meitav-uikit";
const htmlToReactParser = new HtmlToReactParser();

const { UmbracoUtills } = utils;

function SectorItem({
  item,
  riskLevel,
  i,
  anserOld,
  selectedItem,
  setSelectedItem,
  textRecommended,
  sectorChange,
  mode,
}) {
  const htmlToReactParser = new HtmlToReactParser();
  const [isHovered, setIsHovered] = useState(false);

  const resource = UmbracoUpStep(
    useContext(UmbracoContext).resource,
    "Sector" + item.SectorCode
  );

  useEffect(() => {
    if (anserOld != "" && selectedItem == "" && item.SectorCode == anserOld) {
      onItemClick();
    }
  });

  const onItemClick = () => {
    const obj = {};
    obj.code = item.SectorCode;
    obj.name = item.SectorName;
    obj.icon = UmbracoUtills.getValueByKey(resource, "sectorMainIcon");
    setSelectedItem(obj);
    sectorChange(obj);
  };

  return (
    <>
      {riskLevel >= item.FromRiskLevel && (
        <div
          className={`${"sectorItemDiv"} ${
            selectedItem.code === item.SectorCode ? "selected" : ""
          }`}
          role="button"
          aria-label="בחר אפיק השקעה"
          tabIndex={i}
          onKeyPress={() => onItemClick()}
          onClick={() => onItemClick()}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Line className="sectorItem">
            <IconTiny
              src={`${
                import.meta.env.VITE_REACT_APP_IMAGE_URL ||
                window.location.origin
              }${
                isHovered || selectedItem.code === item.SectorCode
                  ? UmbracoUtills.getValueByKey(resource, "sectorSelectedIcon")
                  : UmbracoUtills.getValueByKey(resource, "sectorIcon")
              }`}
            />
            <Row type="shrink">
              <Between>
                <h4>{UmbracoUtills.getValueByKey(resource, "sectorName")}</h4>
                {item.Recommended && mode == "list" && (
                  <div className="SectorItemRecommended">
                    <img></img>
                    {textRecommended}
                  </div>
                )}
              </Between>
              {mode == "list" ? (
                htmlToReactParser.parse(
                  UmbracoUtills.getValueByKey(resource, "sectorDescription")
                )
              ) : (
                <p>
                  {UmbracoUtills.getValueByKey(
                    resource,
                    "sectorShortDescription"
                  )}
                </p>
              )}
            </Row>
          </Line>
        </div>
      )}
    </>
  );
}

export default SectorItem;
